export const MAX_INPUT_LENGTH = 255;
export const MAX_TEXT_LENGTH = 1500;
